import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '../../services/api';
import whiteLogo from '../../images/LOGOTGN.png';
import styles from '../Login/Login.module.css';

const ForgotPasswordPage = () => {
    const [step, setStep] = useState(1); // 1: User, 2: OTP, 3: Password, 4: Success
    const [username, setUsername] = useState('');
    const [otp, setOtp] = useState('');
    const [passwords, setPasswords] = useState({ p1: '', p2: '' });
    const [maskedPhone, setMaskedPhone] = useState('');
    const [userId, setUserId] = useState(null);
    const [timer, setTimer] = useState(180);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        let interval = null;
        if (step === 2 && timer > 0) {
            interval = setInterval(() => setTimer(prev => prev - 1), 1000);
        } else if (timer === 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [step, timer]);

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const data = await request('/forgot_password.php', 'POST', { action: 'send_otp', username });
            if (data.status === 'success') {
                setUserId(data.user_id);
                setMaskedPhone(data.masked_phone);
                setStep(2);
                setTimer(180);
            } else { setError(data.message); }
        } catch { setError('خطا در شبکه'); } finally { setLoading(false); }
    };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const data = await request('/forgot_password.php', 'POST', { action: 'verify_otp', user_id: userId, code: otp });
            if (data.status === 'success') {
                setStep(3);
            } else { setError(data.message); }
        } catch { setError('کد اشتباه است'); } finally { setLoading(false); }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');
        if (passwords.p1 !== passwords.p2) { setError('رمزهای وارد شده همخوانی ندارند.'); return; }
        if (passwords.p1.length < 8) { setError('رمز عبور باید حداقل ۸ کاراکتر باشد.'); return; }

        setLoading(true);
        try {
            const data = await request('/forgot_password.php', 'POST', { 
                action: 'reset_password', user_id: userId, code: otp, password: passwords.p1 
            });
            if (data.status === 'success') {
                // ✅ به جای alert، به گام موفقیت می‌رویم
                setStep(4);
            } else { setError(data.message); }
        } catch { setError('خطا در ثبت رمز جدید'); } finally { setLoading(false); }
    };

    return (
        <div className={styles.parallaxSection}>
            <div className={styles.container}>
                <div className={styles.infoSide}>
                    <img src={whiteLogo} alt="لوگو" className={styles.logo} />
                    <h2 className={styles.welcomeTitle}>بازیابی رمز عبور</h2>
                    <p className={styles.welcomeText}>
                        {step === 4 
                            ? "دسترسی شما با موفقیت بازیابی شد. اکنون می‌توانید با رمز عبور جدید وارد شوید." 
                            : "نگران نباشید! با تایید شماره همراه خود می‌توانید رمز جدید انتخاب کنید."}
                    </p>
                </div>

                <div className={styles.formSide}>
                    <h1 className={styles.formTitle}>
                        {step === 1 && "گام اول: نام کاربری"}
                        {step === 2 && "گام دوم: تایید پیامک"}
                        {step === 3 && "گام سوم: رمز جدید"}
                        {step === 4 && "تغییر موفقیت‌آمیز"}
                    </h1>
                    
                    {error && <div className={styles.errorMessage}>{error}</div>}

                    {/* گام ۱: دریافت نام کاربری */}
                    {step === 1 && (
                        <form onSubmit={handleSendOTP} className={styles.form}>
                            <div className={styles.inputGroup}>
                                <label className={styles.label}>نام کاربری خود را وارد کنید</label>
                                <input className={styles.input} type="text" value={username} onChange={(e) => setUsername(e.target.value)} required placeholder=" نام‌کاربری..." />
                            </div>
                            <button type="submit" className={styles.loginBtn} disabled={loading}>ارسال کد تایید</button>
                        </form>
                    )}

                    {/* گام ۲: ورود کد OTP */}
                    {step === 2 && (
                        <form onSubmit={handleVerifyOTP} className={styles.form}>
                            <p style={{fontSize: '13px', color: '#4b5563', marginBottom: '15px', textAlign: 'right'}}>
                                کد ۶ رقمی به شماره <span dir="ltr" style={{fontWeight:'bold'}}>{maskedPhone}</span> ارسال شد.
                            </p>
                            <input className={styles.input} style={{textAlign: 'center', letterSpacing: '8px', fontSize: '20px'}} type="text" maxLength="6" value={otp} onChange={(e) => setOtp(e.target.value)} required />
                            
                            <div style={{width: '100%', background: '#e5e7eb', height: '6px', borderRadius: '10px', marginTop: '20px', overflow: 'hidden'}}>
                                <div style={{
                                    width: `${(timer / 180) * 100}%`,
                                    background: timer < 30 ? '#ef4444' : '#10b981',
                                    height: '100%', transition: 'width 1s linear'
                                }}></div>
                            </div>
                            <p style={{textAlign: 'center', fontSize: '14px', marginTop: '10px', color: '#374151'}}>
                                زمان باقی‌مانده: {Math.floor(timer/60)}:{String(timer%60).padStart(2,'0')}
                                {timer === 0 && <span style={{color: '#ef4444', cursor: 'pointer', fontWeight: 'bold'}} onClick={() => setStep(1)}> - ارسال مجدد</span>}
                            </p>
                            
                            <button type="submit" className={styles.loginBtn} disabled={loading || timer === 0}>تایید و ادامه</button>
                        </form>
                    )}

                    {/* گام ۳: تنظیم رمز جدید */}
                    {step === 3 && (
                        <form onSubmit={handleResetPassword} className={styles.form}>
                            <div className={styles.inputGroup}>
                                <label className={styles.label}>رمز عبور جدید</label>
                                <input className={styles.input} type="password" placeholder="•••••••" onChange={(e) => setPasswords({...passwords, p1: e.target.value})} required />
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.label}>تکرار رمز عبور جدید</label>
                                <input className={styles.input} type="password" placeholder="•••••••" onChange={(e) => setPasswords({...passwords, p2: e.target.value})} required />
                            </div>
                            <button type="submit" className={styles.loginBtn} disabled={loading}>تغییر رمز عبور</button>
                        </form>
                    )}

                    {/* ✅ گام ۴: نمایش پیام موفقیت نهایی */}
                    {step === 4 && (
                        <div style={{ textAlign: 'center', padding: '20px 0' }}>
                            <div style={{ fontSize: '50px', color: '#10b981', marginBottom: '20px' }}>✓</div>
                            <p style={{ fontSize: '16px', color: '#374151', marginBottom: '30px', lineHeight: '1.6' }}>
                                رمز عبور شما با موفقیت تغییر یافت. <br/>
                                حالا می‌توانید با گذرواژه جدید وارد سیستم شوید.
                            </p>
                            <button 
                                onClick={() => navigate('/login')} 
                                className={styles.loginBtn}
                                style={{ marginTop: '0' }}
                            >
                                بازگشت به صفحه ورود
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;